// extracted by mini-css-extract-plugin
export default {"dragging":"_3zUc-"};